export const en: Record<string, string> = {
  "app.title": "Documents",
  "app.subtitle": "Contracts by clause",
  "settings.language": "Language",
  "settings.theme": "Theme",

  "common.loading": "Loading…",
  "common.close": "Close",
  "common.back": "Back",
  "common.error": "Error",
  "common.retry": "Retry",

  "access.title": "Access restricted",
  "access.body": "Open this app via the Telegram bot using an invite from an administrator.",

  "docs.empty": "No documents loaded yet.",
  "docs.count": "{n} clauses",
  "docs.pages": "pp.",

  "doc.search": "Search clauses…",
  "doc.expand_all": "Expand all",
  "doc.collapse_all": "Collapse all",
  "doc.download_title": "Download whole document",
  "doc.no_results": "Nothing found",
  "doc.results": "Found: {n}",

  "clause.open": "Open",
  "clause.download": "Download clause",
  "clause.speak": "Listen",
  "clause.stop": "Stop",
  "fmt.word": "Word",
  "fmt.pdf": "PDF",

  "download.fail": "Could not download the file",
  "download.preparing": "Preparing file…",

  "share.button": "Share",
  "share.download": "Download",
  "share.format": "Format",
  "share.fail": "Could not share",
  "share.downloaded": "File downloaded",

  "tabs.documents": "Documents",
  "tabs.letters": "Letters",
  "tabs.users": "Users",

  "letters.title": "Letters",
  "letters.subtitle": "Official letters and reports",
  "letters.empty": "No letters yet.",
  "letters.doc_date": "Letter",
  "letters.added": "Added",

  "users.title": "Users & access",
  "users.invite_heading": "Invite a user",
  "users.name_placeholder": "First Last",
  "users.make_admin": "Administrator rights",
  "users.create": "Create invite link",
  "users.creating": "Creating…",
  "users.link_ready": "One-time link (valid 14 days):",
  "users.copy": "Copy",
  "users.copied": "Copied ✓",
  "users.share": "Share",
  "users.share_text": "Invite to the Documents app",
  "users.list_heading": "Users",
  "users.role.admin": "admin",
  "users.role.reader": "reader",
  "users.active": "active",
  "users.inactive": "disabled",
  "users.deactivate": "Disable",
  "users.activate": "Enable",
  "users.empty": "No users yet.",
  "users.invite_fail": "Could not create the invite",
  "users.you": "you",

  "tabs.files": "Files",
  "files.title": "Files & folders",
  "files.new_folder": "New folder",
  "files.folder_name": "Folder name",
  "files.create": "Create",
  "files.empty_folders": "No folders yet.",
  "files.empty_files": "This folder is empty.",
  "files.upload": "Upload file",
  "files.uploading": "Uploading…",
  "files.download": "Download",
  "files.view": "View",
  "files.delete": "Delete",
  "files.confirm_del_folder": "Delete folder and all its files?",
  "files.confirm_del_file": "Delete this file?",
  "files.count": "{n} files",
};
